import { startCase, camelCase } from 'lodash'
import { datetimeFormatter } from 'transfix-ui'
import { formatDate } from 'utils/formatDatetime'
import { TQuoteFilters } from '../types'

export const formatLocation = (
  city?: string | null,
  state?: string | null,
  zip?: string | null
) => {
  const cityString = typeof city === 'string' ? startCase(camelCase(city)) : 'Missing City'
  const stateString = typeof state === 'string' ? state.toUpperCase() : 'Missing State'
  const zipString = typeof zip === 'string' ? zip : '--'
  return `${cityString}, ${stateString} ${zipString}`
}

export const formatExternalId = (externalId?: string | null) => {
  if (typeof externalId === 'string' && externalId.length > 14) {
    return `${externalId.slice(0, 14)}...`
  }
  return externalId
}

export const formatCreatedAtTime = (time?: string | null) => {
  const result = time
    ? datetimeFormatter({
        datetime: time,
        displayTimezone: 'America/New_York',
        format: 'timeDateAndYear',
      })
    : 'N/A'
  return result
}

export const formatPuDelTime = (date?: string | null, time?: string | null) => {
  let dateString = ''
  let timeString = ''
  if (typeof date === 'string') {
    dateString = formatDate(date, 'dateFormat')
  }
  if (typeof time === 'string') {
    timeString = datetimeFormatter({
      datetime: time,
      displayTimezone: 'America/New_York',
      format: 'time',
    })
    timeString += ' EST'
  } else {
    timeString = 'No Time Available'
  }

  if (dateString === '') {
    dateString = 'No Appointment Available'
    timeString = ''
  }
  return [dateString, timeString]
}

export const getDateLimitForQuotes = (quotesFilters: TQuoteFilters) => {
  const currentDate = new Date()
  let displayDate = new Date()

  if (quotesFilters.createdStartDate) {
    displayDate = new Date(quotesFilters.createdStartDate)
    displayDate.setDate(displayDate.getUTCDate())
  } else {
    displayDate = new Date(currentDate)
    displayDate.setFullYear(currentDate.getFullYear() - 1)
  }

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  const formattedDate = displayDate.toLocaleDateString(undefined, options)
  return formattedDate
}

export const formatCustomerQuoteType = (customerQuoteType?: string | null) => {
  let typeOfQuote = 'Unknown Type'

  if (customerQuoteType) {
    typeOfQuote = customerQuoteType
      .split('_')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      .join('-')
  }
  return typeOfQuote
}

export const formatCustomerQuote = (
  customerQuote: number,
  customerQuoteType?: string | null,
  allInQuote?: number | null,
  linehaulQuote?: number | null
) => {
  let typeOfQuote = formatCustomerQuoteType(customerQuoteType)

  if (!customerQuoteType) {
    if (allInQuote && Math.abs(allInQuote - customerQuote) < 1) {
      typeOfQuote = 'All-In'
    }
    if (linehaulQuote && Math.abs(linehaulQuote - customerQuote) < 1) {
      typeOfQuote = 'Linehaul'
    }
  }
  return typeOfQuote
}
